import db from '../../js/db'
import * as types from '../mutations-types'
import { firestoreAction, vuexfireMutations } from 'vuexfire'

const state = {
  user_uid: null,
  user_displayName: '',
  user_claims: {},
  user_aste: [],
}

// getters
const getters = {
  user_uid: state => state.user_uid,
  user_displayName: state => state.user_displayName || '',
  user_pic: state => state.user_claims.fp_pic || null,
  user_aste: state => state.user_aste,
  user_claims: state => state.user_claims,
}

// actions
const actions = {
  /*setAsteRef: firebaseAction(({ bindFirebaseRef }, ref) => {
   bindFirebaseRef('aste', ref, {
   cancelCallback: null,
   readyCallback: null,
   })

   })*/
  setUserId({ commit }, user_uid) {
    commit(types.USER_UID, user_uid)
  },
  setUserDisplayName({ commit }, user_displayName) {
    commit(types.USER_DISPLAY_NAME, user_displayName)
  },
  setUserClaims({ commit }, claims) {
    commit(types.USER_CLM, claims)
  },
  clearUser({ commit }) {
    commit(types.USER_CLR)
  },
  setUser: ({ dispatch }, firebaseUser) => {
    dispatch('setUserId', firebaseUser.uid);

    // l'ho dovuto aggiungere sennò se refreshavo l'asta su standalone mi richiedeva di impostare lo username
    if (firebaseUser.displayName) {
      dispatch('setUserDisplayName', firebaseUser.displayName);
    }

    // console.log('firebaseUser', firebaseUser)
    firebaseUser.getIdTokenResult()
      .then((tokenDecoded) => {
        // console.log('getIdTokenResult', tokenDecoded)
        // let decoded = require('../../js/utils').deconstructJWT(token);
        // console.log('decoded', decoded)
        let claims = _.pick(tokenDecoded.claims, ['fp_uid', 'fp_username', 'fp_pic', 'fp_sessid', 'os'])
        // console.log('claims', claims)
        // do la precedenza al nome di fantapazz
        let displayName = (claims.fp_username) ? claims.fp_username : firebaseUser.displayName;
        dispatch('setUserDisplayName', displayName);
        dispatch('setUserClaims', claims);
      });
  },
}

// mutations
const mutations = {
  [types.USER_UID](state, uid) {
    state.user_uid = uid
  },
  [types.USER_DISPLAY_NAME](state, displayName) {
    state.user_displayName = displayName
  },
  [types.USER_ASTE](state, aste) {
    state.user_aste = aste
  },
  [types.USER_CLM](state, claims) {
    state.user_claims = claims
  },
  [types.USER_CLR](state) {
    state.user_uid = null
    state.displayName = null
    state.user_claims = {}
    state.user_aste = []
  },
  ...vuexfireMutations
}


export default {
  state,
  getters,
  actions,
  mutations
}